import { RetornoDefault } from 'models/Geral/RetornoDefault'
import api from 'services/api.service'

const urlBaseTerrenos = '/parametros'

export const buscarMoedaMrvVigente = async (): Promise<RetornoDefault> => {
  const response = await api.get(`${urlBaseTerrenos}/moedamrv/obter`)
  return response.data as RetornoDefault
}

export const buscarMoedaMrvPorData = async (dataAquisicao: string): Promise<RetornoDefault> => {
  const response = await api.get(`${urlBaseTerrenos}/moedamrv/obterpordata?data=${dataAquisicao}`)
  return response.data as RetornoDefault
}
